import * as React from 'react';

import classNames from 'classnames';

import { Icon } from '@base/components';

import { IconCross } from '@icons';

import * as s from './ActionPanel.scss';

export interface IActionPanelProps {
	className?: string;
	iconClassName?: string;
	icon?: string;
	text: string;
	onClose?(): void;
	onActionClick?(): void;
}

export const ActionPanel: React.FC<IActionPanelProps> =
	({
		className,
		iconClassName,
		icon,
		text,
		onClose,
		onActionClick,
	}: IActionPanelProps) => {
		const classNamesList = classNames(
			s.block,
			className,
		);
		return (
			<div className={classNamesList}>
				<div onClick={onActionClick} className={s.actionZone}>
					{icon && <div className={classNames(s.iconWrapper, iconClassName)} data-test-id="icon">
						<Icon className={s.icon} glyph={icon}/>
					</div>}
					<div className={s.text} data-test-id="text">
						{text}
					</div>
				</div>
				<Icon className={s.closeButton} glyph={IconCross} onClick={onClose}/>
			</div>
		);
	};
